import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, IsUndefinable, LengthWithLVS } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsDefined, IsObject, IsOptional, IsString, ValidateNested } from 'class-validator';
import { MerchantExposeGroup } from '../interface';
import { PatchDictionaryDto } from './PatchDictionaryDto';
import { PatchMerchantContactInfoDto } from './PatchMerchantContactInfoDto';
import { PatchMerchantCountryDto } from './PatchMerchantCountryDto';
import { PatchMerchantFeaturesFlagsDto } from './PatchMerchantFeaturesFlagsDto';
import { PatchMerchantMailerDto } from './PatchMerchantMailerDto';
import { PatchMerchantOrderDto } from './PatchMerchantOrderDto';
import { PatchMerchantPlacePickerDto } from './PatchMerchantPlacePickerDto';
let PatchMerchantDto = class PatchMerchantDto {
};
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50, example: 'Merchant GoParrot' }),
    Expose({
        groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH],
    }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsString({ groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    LengthWithLVS(3, 50, { groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchMerchantDto.prototype, "title", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 250, example: 'Merchant GoParrot Description' }),
    Expose({
        groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH],
    }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsString({ groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    LengthWithLVS(3, 50, { groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchMerchantDto.prototype, "subtitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50 }),
    Expose({
        groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH],
    }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsString({ groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    LengthWithLVS(3, 50, { groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchMerchantDto.prototype, "shortName", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50 }),
    Expose({
        groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH],
    }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsString({ groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    LengthWithLVS(3, 50, { groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchMerchantDto.prototype, "name", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchMerchantContactInfoDto }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsDefined({ groups: [MerchantExposeGroup.UPDATE] }),
    ValidateNested({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    Type(() => PatchMerchantContactInfoDto),
    __metadata("design:type", PatchMerchantContactInfoDto)
], PatchMerchantDto.prototype, "contactInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchMerchantFeaturesFlagsDto }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    ValidateNested({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    Type(() => PatchMerchantFeaturesFlagsDto),
    __metadata("design:type", PatchMerchantFeaturesFlagsDto)
], PatchMerchantDto.prototype, "featuresFlags", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsObject({ always: true }),
    __metadata("design:type", Object)
], PatchMerchantDto.prototype, "shortTermFeatureFlags", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchMerchantMailerDto }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsDefined({ groups: [MerchantExposeGroup.UPDATE] }),
    ValidateNested({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    Type(() => PatchMerchantMailerDto),
    __metadata("design:type", PatchMerchantMailerDto)
], PatchMerchantDto.prototype, "mailer", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchMerchantOrderDto }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsDefined({ groups: [MerchantExposeGroup.UPDATE] }),
    ValidateNested({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    Type(() => PatchMerchantOrderDto),
    __metadata("design:type", PatchMerchantOrderDto)
], PatchMerchantDto.prototype, "order", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchMerchantPlacePickerDto }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsDefined({ groups: [MerchantExposeGroup.UPDATE] }),
    ValidateNested({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    Type(() => PatchMerchantPlacePickerDto),
    __metadata("design:type", PatchMerchantPlacePickerDto)
], PatchMerchantDto.prototype, "placePicker", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchDictionaryDto }),
    Expose({
        groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.CREATE, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH],
    }),
    IsUndefinable({ groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    ValidateNested({ always: true }),
    Type(() => PatchDictionaryDto),
    __metadata("design:type", PatchDictionaryDto)
], PatchMerchantDto.prototype, "dictionary", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchMerchantCountryDto }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsDefined({ groups: [MerchantExposeGroup.UPDATE] }),
    ValidateNested({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    Type(() => PatchMerchantCountryDto),
    __metadata("design:type", PatchMerchantCountryDto)
], PatchMerchantDto.prototype, "country", void 0);
PatchMerchantDto = __decorate([
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.CREATE, MerchantExposeGroup.PATCH, MerchantExposeGroup.UPDATE] })
], PatchMerchantDto);
export { PatchMerchantDto };
//# sourceMappingURL=PatchMerchantDto.js.map